import styled from "styled-components";
import { Props } from "./Backdrop";

export const StyledDiv = styled.div<Props>`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 100;
  transform: ${({ open }) => (open ? "translateX(0)" : "translateX(100%)")};

  @media (min-width: 1050px) {
    transform: translate(100%);
  }
`;
